import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Besoin en eau journalier : 9 courbes (horizon x statistique), via
 * CourbesStatChart. Statistiques proposées : Moyen, Quantile 75 et Quantile 90
 * (pas de Maximum). Coché à l'ouverture : Moyen.
 *
 * Tableau : pour 2035 et 2050, chaque colonne est l'écart (en valeur, plus en
 * %) entre la statistique de l'année et le Moyen de 2020 — par exemple
 * q75_2035 - moyen_2020 pour la colonne Quantile 75 de 2035.
 */
export default function EauChart({ data, uniteElevage = false }) {
  // En élevage le besoin s'exprime par tête et non en lame d'eau.
  const unite = uniteElevage ? "L/tête/j" : "mm/j";
  return (
    <CourbesStatChart
      data={data}
      prefixe="besoin"
      cleDate="date_affichage"
      unite={unite}
      nomAxe={unite}
      statsParDefaut={["moy"]}
      statsDisponibles={["moy", "q75", "q90"]}
      tableauEnEcart
      // En élevage, l'axe Y démarre au minimum réel des données (arrondi à
      // l'entier inférieur) : l'échelle automatique écrasait les écarts.
      yMinAuto={uniteElevage}
    />
  );
}
